import { Link } from 'react-router-dom';
import Logo from '@/components/feature/Logo';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div className="lg:col-span-1">
            <Logo variant="light" />
            <p className="mt-5 text-sm text-background-200 leading-relaxed max-w-xs">
              La plateforme qui simplifie l'accès aux soins à Rabat : médecins, laboratoires,
              radiologie, pharmacies et paramédical, en quelques clics.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-4">
              <a href="#recherche" className="cursor-pointer">Patients</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li><a href="#recherche" className="hover:text-primary-300 cursor-pointer">Trouver un médecin</a></li>
              <li><a href="#recherche" className="hover:text-primary-300 cursor-pointer">Trouver un laboratoire</a></li>
              <li><a href="#recherche" className="hover:text-primary-300 cursor-pointer">Trouver une pharmacie</a></li>
              <li><a href="#comment" className="hover:text-primary-300 cursor-pointer">Comment ça marche</a></li>
              <li><a href="#faq" className="hover:text-primary-300 cursor-pointer">Questions fréquentes</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-4">
              <a href="#praticiens" className="cursor-pointer">Praticiens</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li><a href="#praticiens" className="hover:text-primary-300 cursor-pointer">Inscrivez votre entreprise</a></li>
              <li><a href="#praticiens" className="hover:text-primary-300 cursor-pointer">Boostez votre visibilité</a></li>
              <li><a href="#praticiens" className="hover:text-primary-300 cursor-pointer">Faites-vous connaître</a></li>
              <li><a href="#praticiens" className="hover:text-primary-300 cursor-pointer">Espace praticien</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-background-50 mb-4">
              <a href="#contact" className="cursor-pointer">Contact & légal</a>
            </h4>
            <ul className="space-y-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-300 text-base w-4 h-4 flex items-center justify-center mt-0.5" />
                <span>Rabat, Maroc</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-300 text-base w-4 h-4 flex items-center justify-center mt-0.5" />
                <a
                  href="mailto:contact@medicaclic.com"
                  className="hover:text-primary-300 cursor-pointer"
                >
                  contact@medicaclic.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-whatsapp-line text-primary-300 text-base w-4 h-4 flex items-center justify-center mt-0.5" />
                <span>
                  <span className="block text-xs text-background-300">Une question ?</span>
                  <a
                    href="https://wa.me/212612865005?text=Bonjour%2C%20je%20souhaite%20des%20informations%20via%20MedicaClic"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-medium text-background-50 hover:text-primary-300 cursor-pointer"
                  >
                    Écrivez-nous sur WhatsApp
                  </a>
                </span>
              </li>
              <li className="pt-2"><Link to="/mentions-legales" className="hover:text-primary-300 cursor-pointer">Mentions légales</Link></li>
              <li><Link to="/cgu" className="hover:text-primary-300 cursor-pointer">CGU / CGV</Link></li>
              <li><Link to="/politique-de-confidentialite" className="hover:text-primary-300 cursor-pointer">Politique de confidentialité</Link></li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-300">
            © 2026 MEDICACLIC · ICE 003548663000080
          </p>
          <div className="flex items-center gap-5">
            <p className="text-xs text-background-300">
              Conforme Loi 09-08 (CNDP)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}